/** The design fans three; a practice that earned more says so with the tab's dot. */
export const MAX_EARNED_CARDS = 3

/** A first card or a new rung earns the fan; growth inside a rung does not. */
const WORTH_FANNING = new Set(['UNLOCKED', 'TIER_UP'])

/** Only the fields the fan reads — the query asks for no more. */
export interface PendingChange {
  exerciseId: string
  case: string
  thumbnailUrl?: string | null
}

export interface EarnedCard {
  id: string
  thumbnailUrl: string | null
}

/** What the wall is already holding back, to be told apart from what a completion adds. */
export function pendingIds(changes: readonly PendingChange[]): Set<string> {
  return new Set(changes.map((c) => c.exerciseId))
}

/**
 * Asks what is NEW, never what is mine: a day's exercise id and a change's `exerciseId` are
 * different id spaces, so narrowing by the practice's own ids returns empty on a completion that
 * did earn a card. Measured on device, on Android, before this was ported.
 */
export function selectEarnedCards(
  changes: readonly PendingChange[],
  arrivedSince: ReadonlySet<string>,
): EarnedCard[] | null {
  const earned = changes
    .filter((c) => WORTH_FANNING.has(c.case) && !arrivedSince.has(c.exerciseId))
    .slice(0, MAX_EARNED_CARDS)
    .map((c) => ({ id: c.exerciseId, thumbnailUrl: c.thumbnailUrl ?? null }))
  return earned.length > 0 ? earned : null
}
